import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { tableTextStyles } from "../../WorkflowFlatTable";

interface WorkflowScopeTableFindingCellProps {
  value: string;
  url?: string;
  onLinkClick?: () => void;
}

export default function WorkflowScopeTableFindingCell({
  value,
  url,
  onLinkClick,
}: WorkflowScopeTableFindingCellProps) {
  const linkProps = url
    ? {
        component: Link,
        to: url,
        onClick: onLinkClick,
      }
    : {};

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        flex: "1 0 0",
        height: "100%",
      }}
    >
      <Typography
        {...linkProps}
        sx={{
          ...tableTextStyles,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}
